import React from 'react';
import { startingPageImg } from './assets/images/index';
import './layouts/general-layout/layout.scss';
import './pages/startingpage1/startingpage1.scss';

const App = () => {
  return (
    <div className="pages-layout no-header" dir="rtl">
      <div className="main-body" style={{ backgroundColor: '#fff' }}>
        <div className="full-head-template starting-page" style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
          <div className="starting-page-body">
            <div className="starting-page-image">
              <img src={startingPageImg} alt="MainImage" />
            </div>
            <div>
              <h4 className="starting-page-title">
                סביבת הפיתוח
                <span>
                  כבר לא זמינה,
                  <br />
                  היא עודכנה בסביבה האמיתית!
                </span>
              </h4>
            </div>
          </div>
          <div className="starting-page-action" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <a
              href="https://users.shoonit.com"
              style={{
                display: 'inline-block',
                backgroundColor: '#1ccce0',
                color: '#ffffff',
                padding: '16px 24px',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                textDecoration: 'none',
                boxShadow: '0 4px 10px rgba(37, 99, 235, 0.2)',
                transition: 'background-color 0.2s',
                textAlign: 'center',
                width: '100%',
                boxSizing: 'border-box'
              }}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
            >
              לחץ כאן כדי לעבור לאפליקציה בסביבה האמיתית
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
